import React, { useEffect, useState } from "react";
import Header from "../Header/Header";
import styles from "./VisitRegistration.module.css";
import SidebarComponent from "../Reusables/SidebarComponent";
import useAxios from "../Hooks/useAxios";
import { useNavigate } from "react-router-dom";
import Select from "./SelectVR";
import Footer from "../Footer/Footer";
import AddressPopupContent from "../Reusables/AddressPopupContent/AddressPopupContent";

const VisitRegistration = () => {
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const axios = useAxios();
  const navigate = useNavigate();
  const [showAddressPopup, setShowAddressPopup] = useState(false);
  const [addresses, setAddresses] = useState(null);
  const [agree, setAgree] = useState(false);
  const [plans, setPlans] = useState([]);
  const [planInput, setPlanInput] = useState("");
  const [studioInput, setStudioInput] = useState("");
  const [studios, setStudios] = useState([]);
  // get today's date
  const [date, setDate] = useState(currentDate());
  const [photo, setPhoto] = useState("");
  const [name, setName] = useState("");
  function handleAddressPopup() {
    setShowAddressPopup((prev) => !prev);
  }
  function currentDate() {
    const date = new Date();
    const year = date.getFullYear();
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const day = ("0" + date.getDate()).slice(-2);
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }
  const submit = () => {
    if (!agree) {
      alert("規約に同意してください");
      return;
    }
    if (
      photo === "" ||
      name === "" ||
      date === "" ||
      planInput === "" ||
      studioInput === ""
    ) {
      alert("Please select all fields");
      return;
    }
    let data = {
      date: date,
      plan: planInput.id,
      studio: studioInput.id,
      is_post_photo: photo,
      is_post_name: name,
    };
    console.log(data);
    axios
      .post(backend_base + "/home/visit-registration", data)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          navigate("/visit-reg-success");
        } else {
          console.log("Failed to post visit registration data");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const handlePhotoChange = (e) => {
    setPhoto(e.target.value);
  };

  const handleNameChange = (e) => {
    setName(e.target.value);
  };
  const handleDateChange = (e) => {
    alert(e.target.value);
    setDate(e.target.value);
  };
  const handlePlanChange = (value) => {
    setPlanInput(value);
  };

  const handleStudioChange = (value) => {
    setStudioInput(value);
  };
  useEffect(() => {
    axios
      .get(backend_base + "/home/visit-registration")
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          // setAllProducts(res.data.products);
          // setSubtotal(res.data.subtotal);
          console.log(res.data);
          setAddresses(res.data?.addresses);
          setPlans(res.data.plans);
          setStudios(res.data.studios);
        } else {
          console.log("Failed");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);
  return (
    <>
      <Header />

      <div className={styles.visit}>
        <div className={styles.sidebar_wrapper01}>
          <SidebarComponent />
        </div>

        <div className={`${styles.visitcontent}`}>
          <div className={styles.header001_wrapper}>
            <div className={styles.header002}>来店登録</div>
            <div className={styles.header003}>
              ご来店時に、店頭にてご登録いただくページです。
            </div>
          </div>
          <div className={styles.inp_wrapper001}>
            <div className={styles.label001}>日付</div>
            <Select datepicker={true} callback={handleDateChange} />
          </div>
          <div className={styles.inp_wrapper001}>
            <div className={styles.label001}>プラン</div>
            <Select
              datepicker={false}
              selected={planInput.name}
              options={plans}
              callback={handlePlanChange}
            />
          </div>
          <div className={styles.inp_wrapper001}>
            <div className={styles.label001}>スタジオ</div>
            <Select
              datepicker={false}
              selected={studioInput.name}
              options={studios}
              callback={handleStudioChange}
            />
          </div>
          <div
            className={`${styles.popup_button} py-3`}
            onClick={handleAddressPopup}
          >
            <i className="fa fa-play" aria-hidden="true"></i>
            <span className="ml-2">登録住所を確認</span>
          </div>
          <div className={styles.header004_wrapper}>
            <div className={styles.header005}>掲載について</div>
            <div className={styles.header006}>
              掲載について 最終更毎日
              <span className={styles.span001}>{currentDate()}</span>
            </div>
          </div>
          <div className={styles.box001}>
            <div className={styles.text001}>
              以下の内容でご登録いただいておりますが、変更はございませんか？
            </div>

            <div className={`${styles.box002}`}>
              <div className={styles.q001}>
                1.撮影したお写真をHPやSNSなどに掲載してもよろしいですか？
              </div>
              <div className={`d-flex  ${styles.radio}`}>
                <div className={styles.radio_left01}>
                  <input
                    className={styles.radioInput}
                    type="radio"
                    name="isPhoto"
                    value="家族全員OK"
                    onChange={handlePhotoChange}
                  />
                  <div className={styles.text002}>家族全員OK</div>
                </div>

                <div className="d-flex ml-3">
                  <input
                    className={styles.radioInput}
                    type="radio"
                    name="isPhoto"
                    value="こどものみOK"
                    onChange={handlePhotoChange}
                  />
                  <div className={styles.text002}>こどものみOK</div>
                </div>

                <div className="d-flex ml-3">
                  <input
                    className={styles.radioInput}
                    type="radio"
                    name="isPhoto"
                    value="掲載NG"
                    onChange={handlePhotoChange}
                  />
                  <div className={styles.text002}>掲載NG</div>
                </div>
              </div>
              <div className={styles.q002}>
                2.【OKの場合】お名前の掲載はしてもよろしいですか？
              </div>
              <div className={`d-flex  ${styles.radio}`}>
                <div className={styles.radio_left01}>
                  <input
                    className={styles.radioInput}
                    type="radio"
                    name="isName"
                    value={"名前掲載OK"}
                    onChange={handleNameChange}
                  />
                  <div className={styles.text002}>名前掲載OK</div>
                </div>

                <div className="d-flex ml-3">
                  <input
                    className={styles.radioInput}
                    type="radio"
                    name="isName"
                    value="名前掲載NG"
                    onChange={handleNameChange}
                  />
                  <div className={styles.text002}>名前掲載NG</div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.text003}>
            <div>
              ※これまでにご来店いただき【掲載OK】とされていた方は、すでにHPやSNSに掲載している場合がございます。
            </div>

            <div>
              すでに掲載した写真の削除をご希望の場合、恐れ入りますが具体的なお写真をご提示くださいませ。
            </div>
          </div>
          <div className={styles.header006_wrapper}>
            <div className={styles.header007}>撮影に関しての同意</div>
          </div>
          <div className={styles.text004}>
            本日の撮影の流れをご確認いただけましたら、同意のボタンを押してください。
          </div>

          <div className={styles.button01_wrapper}>
            <div className={styles.sub_row01}>
              <input
                type="checkbox"
                className={styles.photo_checkbox_input}
                checked={agree}
                onChange={() => {
                  setAgree(!agree);
                }}
              />
              <div className={styles.text005}>同意する</div>
            </div>
            <div onClick={submit} className={styles.button1}>
              登　録
            </div>
          </div>
        </div>
      </div>
      {showAddressPopup && (
        <AddressPopupContent
          addresses={addresses}
          handleOpenAddressPopup={handleAddressPopup}
        />
      )}
      <Footer />
    </>
  );
};

export default VisitRegistration;
